import { render, staticRenderFns } from "./TestItems.vue?vue&type=template&id=32458576&"
import script from "./TestItems.vue?vue&type=script&lang=js&"
export * from "./TestItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports